import axios from 'axios';

/*
*  This file contains all axios calls related add contacts to automation
*/

export const clearPotentialContactsList = async (funnelId) => {
    await axios.delete(`/app/funnel/potentialContacts/${funnelId}`);
};
